import { useEffect, useState } from "react";
import { fetchExternalSystems, downloadExternalSystemsExcel } from "../Api/ViewExternalSystem";
import { Container, Table, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import moment from "moment";

const ViewExternalSystem = () => {
  const [externalSystems, setExternalSystems] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    const loadExternalSystems = async () => {
      try {
        const data = await fetchExternalSystems();
        setExternalSystems(data || []);
      } catch (error) {
        toast.error(`🦄 Error Fetching External Systems`);
      }
    };

    loadExternalSystems();
  }, []);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const response = await downloadExternalSystemsExcel();
      
      if (!response.data) {
        throw new Error("No data received from server");
      }
      
      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'ExternalSystems_Data.xlsx');
      
      // Trigger download
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
      }, 100);
      
      toast.success("External Systems data download started!");
    } catch (error) {
      console.error("Download error:", error);
      toast.error(`🦄 Download failed: ${error.message}`);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <>
      
        <div className="main-content expand">
          <Container fluid className="list-container">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h2 className="list-title">View External Systems</h2>
              <Button 
                className="generate-btn"
                variant="primary" 
                onClick={handleDownload}
                disabled={isDownloading || externalSystems.length === 0}
              >
                {isDownloading ? 'Downloading...' : 'Download Data'}
              </Button>
            </div>

            {externalSystems.length > 0 ? (
              <Table bordered hover responsive className="data-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>System ID</th>
                    <th>External Code</th>
                    <th>Description</th>
                    <th>Created On</th>
                    <th>Created By</th>
                    <th>Changed On</th>
                    <th>Changed By</th>
                  </tr>
                </thead>
                <tbody>
                  {externalSystems.map((system, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{system.externalSystemId}</td>
                      <td>{system.externalCode}</td>
                      <td>{system.description}</td>
                      <td>
                        {moment(system.createdOnDate).format('L')} at {system.createdOnTime?.substring(0, 8)}
                      </td>
                      <td>{system.createdBy}</td>
                      <td>
                        {system.changedOnDate ? 
                          `${moment(system.changedOnDate).format('L')} at ${system.changedOnTime?.substring(0, 8)}` : 
                          'N/A'}
                      </td>
                      <td>{system.changedBy || 'N/A'}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <p className="no-data">No external systems found.</p>
            )}
          </Container>
        </div>
      
    </>
  );
};

export default ViewExternalSystem;